import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("aura_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("aura_token");
  }
};

const saved = localStorage.getItem("aura_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

// Always attach the freshest token from storage on every request.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("aura_token");
  if (t) config.headers["Authorization"] = `Bearer ${t}`;
  return config;
});
